import * as actions from './actions'
import * as mutations from './mutations'

export default{
  namespaced:true,
  state: () => ({
    isLogin: false,
    showLogin: false,
    user: null,
    level: false,
    isRedirect: true
  }),
  actions,
  mutations

}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js